
import { useState, useEffect } from "react";
import DeleteDeviceModal from "../DeleteDeviceModal.js";
import { deleteDevice } from '../../../utilities/orgPanelApiCalls.js';
import { errorToast, successToast } from '../../../constants/toast';
import { useStore } from "../../../utilities/appStore";



export default function DeleteDeviceModalViewModel({subscriptionId, deviceData, toastCallback, pageToggle, completeCallback }) {

    let [isModalShowing, setIsModalShowing] = useState(true);
    let [isModalLoading, setIsModalLoading] = useState(false);

    let orgId = useStore((state) => state.CurrentOrganizationId);



    const toggleModal = () => {
        setIsModalShowing(!isModalShowing);
        pageToggle();
    }

    const handleDelete = async (event) => {
        event.preventDefault();
        let accountId = parseInt(deviceData.accountId);

        setIsModalLoading(true);
        var response = await deleteDevice(orgId, accountId);

        if (response.status > 299) {
            toastCallback(response.data, errorToast);
            setIsModalLoading(false);
        }
        else {
            toastCallback("Device Deleted!", successToast);
            setIsModalLoading(false);
            toggleModal();
            completeCallback();
        }
    }



    return (
        <DeleteDeviceModal
            submitHandler={handleDelete}
            deviceData={deviceData}
            isOpen={isModalShowing}
            handleClose={toggleModal}
            isLoading={isModalLoading}
        />
    )
}